"use client";

import * as React from "react";
import { useRouter } from "next/navigation";
import JournalTable, { type JournalRow } from "./JournalTable";
import NewJournalEntryModal from "./NewJournalEntryModal";

export default function JournalScreen({ data }: { data: JournalRow[] }) {
  const router = useRouter();
  const [open, setOpen] = React.useState(false);
  const [q, setQ] = React.useState("");
  const combined = data;

  const filtered = React.useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return combined;
    return combined.filter((r) =>
      [r.date, r.ref, r.text, r.debit, r.credit, r.amount, r.status]
        .join(" ")
        .toLowerCase()
        .includes(s)
    );
  }, [combined, q]);

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1 style={{ marginBottom: 4 }}>Journal</h1>
          <div style={{ color: "var(--muted)", fontSize: 13 }}>
            Sortieren per Klick auf Spaltenkopf · Auto-Buchungen kommen aus Inbox
          </div>
          <div style={{ color: "var(--muted)", fontSize: 12, marginTop: 4 }}>
            Legende: <span className="pill pill-review">≥ 90.0 % sicher</span>{" "}
            <span className="pill pill-provisional">&lt; 90.0 % PROVISORISCH</span>
          </div>
        </div>

        <div className="page-actions">
          <input
            className="input input-compact"
            placeholder="Suchen…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <button className="btn" type="button" onClick={() => router.refresh()} title="Neu laden">
            Neu laden
          </button>
          <button className="primary-btn" type="button" onClick={() => setOpen(true)}>
            Neue Buchung
          </button>
        </div>
      </div>

      <JournalTable data={filtered} />

      <NewJournalEntryModal
        open={open}
        onClose={() => setOpen(false)}
        onSaved={() => router.refresh()}
      />
    </div>
  );
}
